import Timer from "../../components/ui/Timer";
import icone_XP from '../../assets/imagens/icone_XP.png';

import {useEffect, useState} from 'react'

import { API_URL } from "../../config/api";

import "./InicialChamado.css"
export default function InicialChamado ({maxScore, sla, setTempoAcabou, audioTimerRef, userTicketId}) {
    
    const [time, setTime] = useState(null)
    const token = localStorage.getItem("token"); 

    const getTime = (time) =>{
        if(time === null){
            setTime(sla)
            console.log("Cheguei aqui", sla)
        }
        else{
            var startTime = new Date(time).getTime()
            var now = Date.now()
            
            var difference =parseInt((now - startTime) /1000)
            const remaining = Math.max(0, sla - difference);
            setTime(remaining)
        }
    }

    useEffect(() => {
      const checkTime = async ()=>{
        await fetch(`${API_URL}/tickets/checkTime/${userTicketId}`,{
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(response => {
                if (!response.ok) {
                throw new Error(`Erro: ${response.status}`);
                }
                return response.json(); 
                
            })
            .then(data => {
                getTime(data);
            })
            .catch(error => {
                console.error('Erro na requisição:', error.message);
            });
    }      

    checkTime() 
       
    }, []);

    return(
        <div className="flex parteInicial">

                    <div className="flex">

                        {time !== null && 
                        
                            <Timer 
                                sla={time}
                                onStart={() => audioTimerRef.current?.play()}
                                onComplete={() => {
                                    audioTimerRef.current?.pause();
                                    audioTimerRef.current.currentTime = 0;
                                    setTempoAcabou(true)
                            }}
                        />
                        }
                    </div>

                    <div className="flex pontos">

                        <img
                            width={25}
                            src={icone_XP}
                        />

                        <p className="numero">
                            {maxScore}
                        </p>

                    </div>

                </div>
    )
}